import { internalNavigationTarget } from "./navigationTarget.ts";

const POST_FALLBACK = "/marketplace";

/** [posting.safe-return](../../../docs/product/marketplace.md#posting-safe-return): Keep already-decoded post-flow returns internal; invalid targets use the marketplace. */
export function safeReturnTo(value?: string | null): string {
  if (!value?.startsWith("/") || value.startsWith("//")) return POST_FALLBACK;
  return internalNavigationTarget(value) ?? POST_FALLBACK;
}

export function postHref(type: string, returnTo = POST_FALLBACK, start?: "details"): string {
  if (type === "resume") return "/dashboard";
  const params = new URLSearchParams({ returnTo: safeReturnTo(returnTo) });
  if (start === "details") params.set("start", start);
  return `/post/${encodeURIComponent(type)}?${params.toString()}`;
}
